(function (win) {
    'use strict';
    var fp = (win.fp = typeof win.fp !== 'undefined' ? win.fp : {}),
        home = (fp.home = typeof fp.home !== 'undefined' ? fp.home : {});

    // =========================================
    // Lazy Load Slideshow
    // =========================================
    var lazyLoadSlideshow = function () {
        document.querySelectorAll('.cycle-slideshow img[data-src]').forEach(function (img) {
            img.setAttribute('src', img.getAttribute('data-src'));
            img.setAttribute('srcset', img.getAttribute('data-srcset'));
            img.setAttribute('sizes', img.getAttribute('data-sizes'));
            img.onload = function () {
                img.removeAttribute('data-src');
                img.removeAttribute('data-srcset');
                img.removeAttribute('data-sizes');
            };
        });
    };

    // =========================================
    // Setup Video Controls
    // =========================================
    var setupVideoControls = function () {
        var video = document.getElementById('bg-video');
        var videoButton = document.getElementById('video-pause-play');
        var videoButtonIcon = videoButton ? videoButton.querySelector('span') : null;
        var controlAnnouncements = document.getElementById('video-control-announcements');

        if (!video || !videoButton || !videoButtonIcon || !controlAnnouncements) return;

        videoButton.addEventListener('click', function () {
            if (!video.paused) {
                video.pause();
                videoButton.setAttribute('aria-label', 'Play video');
                videoButtonIcon.classList.replace('icon-pause', 'icon-play');
                controlAnnouncements.textContent = 'Video paused';
            } else {
                video.play();
                videoButton.setAttribute('aria-label', 'Pause video');
                videoButtonIcon.classList.replace('icon-play', 'icon-pause');
                controlAnnouncements.textContent = 'Video playing';
            }
        });
    };

    // =========================================
    // Setup Carousel Controls
    // =========================================
    const setupCarouselControls = () => {
        const carouselWrapper = document.querySelector('.slideshow');
        const carouselTarget = document.querySelector('.cycle-slideshow');
        const ariaLiveRegion = document.querySelector('#control-announcements');

        // Ensure the carousel target exists and the cycle plugin is available
        if (!carouselTarget || typeof $.fn.cycle !== 'function') return;

        // Initialize the carousel
        $(carouselTarget).cycle();

        // Pause the carousel on mouseenter
        /*
        if (carouselWrapper) {
            carouselWrapper.addEventListener('mouseenter', () => {
                if (!carouselTarget.classList.contains('hard-pause')) {
                    $(carouselTarget).cycle('pause');
                }
            });

            carouselWrapper.addEventListener('mouseleave', () => {
                if (!carouselTarget.classList.contains('hard-pause')) {
                    $(carouselTarget).cycle('resume');
                }
            });
        }
        */

        // Handle the play/pause button
        const cyclePausePlay = document.querySelector('#cycle-pause-play');
        const cyclePausePlayIcon = cyclePausePlay ? cyclePausePlay.querySelector('span') : null;

        if (cyclePausePlay) {
            cyclePausePlay.addEventListener('click', function () {
                const isPaused = carouselTarget.classList.contains('hard-pause');

                // Update play/pause state
                if (isPaused) {
                    carouselTarget.classList.remove('hard-pause');
                    this.setAttribute('aria-label', 'Pause carousel');
                    if (cyclePausePlayIcon) {
                        cyclePausePlayIcon.classList.replace('icon-play', 'icon-pause');
                    }
                    ariaLiveRegion.textContent = 'Carousel is playing.';
                    $(carouselTarget).cycle('resume');
                } else {
                    carouselTarget.classList.add('hard-pause');
                    this.setAttribute('aria-label', 'Play carousel');
                    if (cyclePausePlayIcon) {
                        cyclePausePlayIcon.classList.replace('icon-pause', 'icon-play');
                    }
                    ariaLiveRegion.textContent = 'Carousel is paused.';
                    $(carouselTarget).cycle('pause');
                }
            });
        }

        // Handle the "Back" button
        const cycleBack = document.querySelector('#cycle-back');
        if (cycleBack && ariaLiveRegion) {
            cycleBack.addEventListener('click', () => {
                ariaLiveRegion.textContent = 'Reading previous slide.';
            });
        }

        // Handle the "Next" button
        const cycleNext = document.querySelector('#cycle-next');
        if (cycleNext && ariaLiveRegion) {
            cycleNext.addEventListener('click', () => {
                ariaLiveRegion.textContent = 'Reading next slide.';
            });
        }
    };

    // =========================================
    // Adjust Hero Section
    // =========================================
    var adjustHero = function () {
        var mainHeader = document.querySelector('#main-header');
        var headerHeight = mainHeader ? parseInt(mainHeader.offsetHeight, 10) : 0;

        var modernBrowserWrapper = document.querySelector('.modern-browser-wrapper');
        var pageMarginTop = modernBrowserWrapper ? parseInt(getComputedStyle(modernBrowserWrapper).marginTop, 10) : 0;

        var adjustment = (headerHeight + pageMarginTop + 5) * -1;

        var hero = document.querySelector('#hero');
        if (hero) {
            hero.style.marginTop = `${adjustment}px`;
        }
    };

    // =========================================
    // Set Hero Height
    // =========================================
    var setHeroHeight = function () {
        var height = window.innerHeight;

        var header = document.querySelector('header');
        var headerHeight = header ? header.offsetHeight : 0;

        var specialMessage = document.querySelector('#special-message.message-banner');
        var specialMessageHeight = specialMessage && specialMessage.offsetParent !== null ? specialMessage.offsetHeight : 0;

        var fixedFooter = document.querySelector('#fixed-footer');
        var fixedFooterHeight = 0;

        if (fixedFooter) {
            //console.log("Fixed footer found in DOM.");
            //console.log("Initial Computed Height:", fixedFooter.offsetHeight);

            // Trigger reflow to ensure accurate measurement
            fixedFooter.offsetHeight; // Force layout calculation
            fixedFooterHeight = fixedFooter.offsetHeight || 0;

            //console.log("Final Computed Height:", fixedFooterHeight);
        }

        var widthDetection = document.querySelector('#width-detection');
        var floatValue = widthDetection ? getComputedStyle(widthDetection).float : 'none';

        //console.log("FLOAT VALUE:", floatValue);
        //console.log("HEADER HEIGHT:", headerHeight);
        //console.log("SPECIAL MESSAGE HEIGHT:", specialMessageHeight);
        //console.log("FIXED FOOTER HEIGHT:", fixedFooterHeight);

        var minHeight = height - specialMessageHeight - fixedFooterHeight + 5;
        if (floatValue === 'none') {
            minHeight = height - headerHeight - specialMessageHeight - fixedFooterHeight;
        }

        document.documentElement.style.setProperty('--bg-video-height', `${minHeight}px`);
    };

    // Ensure the function runs after styles are fully applied
    //window.addEventListener('load', setHeroHeight);

    // =========================================
    // Scroll Event Logic
    // =========================================
    window.addEventListener('scroll', function () {
        var height = window.scrollY || window.pageYOffset;
        document.body.classList.toggle('scrolled-down', height > 50);
    });

    // =========================================
    // Resize Event Logic with Debounce
    // =========================================
    var debounce = function (func, wait) {
        var timeout;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(func, wait);
        };
    };

    window.addEventListener(
        'resize',
        debounce(function () {
            setHeroHeight();

            var widthDetection = document.querySelector('#width-detection');
            var floatValue = widthDetection ? getComputedStyle(widthDetection).float : 'none';

            if (floatValue !== 'none') {
                adjustHero();
            } else {
                var hero = document.querySelector('#hero');
                if (hero) {
                    hero.removeAttribute('style');
                }
            }
        }, 200)
    );

    // =========================================
    // Remove fade-home-contents Class on Load
    // =========================================
    var removeFadeHomeContents = function () {
        setTimeout(function () {
            document.body.classList.remove('fade-home-contents');
        }, 1000);
    };

    // =========================================
    // Public API
    // =========================================
    fp.home.init = function () {
        var homepageLink = document.querySelector('.homepage-link');
        if (homepageLink) homepageLink.classList.add('selected');

        lazyLoadSlideshow();
        adjustHero();
        setHeroHeight();
        setupCarouselControls();
        setupVideoControls();
        removeFadeHomeContents();
    };

})(window);